/**
 * Points de retrait — reflet de `backend/magasins.py`.
 *
 * La source de vérité est le fichier Python : c'est lui qui décide ce qui
 * est facturé et enregistré. Cette copie sert à afficher le choix sans
 * attendre une réponse du serveur. Les deux se tiennent à jour ensemble,
 * même discipline que pour les zones de livraison.
 *
 * Une liste dès maintenant, bien qu'il n'y ait qu'un magasin : le jour où un
 * deuxième ouvre, le choix apparaît sans toucher au tunnel de commande.
 */

export const MODE_LIVRAISON = 'livraison';
export const MODE_MAGASIN = 'magasin';

export const MAGASINS = [
  {
    id: 'liege-saint-nicolas',
    nom: 'AfriOne BD',
    adresse: 'Rue St Nicolas 227',
    code_postal: '4000',
    ville: 'Liège',
    telephone: '0465 71 01 17',
    horaires_fr: 'Lundi au vendredi 9h30 – 20h · Samedi et dimanche 10h – 19h30',
    horaires_en: 'Monday to Friday 9:30am – 8pm · Saturday and Sunday 10am – 7:30pm',
    actif: true,
  },
];

export const magasinsActifs = () => MAGASINS.filter((m) => m.actif !== false);

export const trouverMagasin = (id) => MAGASINS.find((m) => m.id === id) || null;

export const adresseComplete = (m) =>
  (m ? `${m.nom}, ${m.adresse}, ${m.code_postal} ${m.ville}` : '');
